<template>
    <v-form ref="form" :disabled="isSubmitting" @submit.prevent="submit">
        <v-date-input
            v-model="startDate"
            label="Criados desde"
            :max="today"
            input-format="yyyy-mm-dd"
            autocomplete="off"
            :rules="[formValidationRules.required(startDate)]"
            :disabled="isSubmitting"
        />
        <v-date-input
            v-model="endDate"
            label="Atualizados até"
            :min="startDate"
            input-format="yyyy-mm-dd"
            autocomplete="off"
            hint="Se não indicar uma data, será usado o dia de hoje."
            persistent-hint
            :disabled="isSubmitting"
            :rules="[(value) => !value || !startDate || value >= startDate || 'A data final deve ser igual ou posterior à inicial.',]"
        />
        <p class="mt-4">
            A exportação será preparada em segundo plano. Pode acompanhar o estado em
            <router-link :to="{ name: 'exports', query: { export_type: 'department-membership-requests', }, }" target="_blank">As minhas exportações</router-link>.
        </p>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import dayjs from "dayjs";

import formValidationRules from "@/composables/formValidationRules";

const props = defineProps({
    onSubmit: { type: Function, required: true, },
    idempotency_key: { type: String, required: true, },
});

const form = ref(null);
const startDate = ref("");
const endDate = ref("");
const today = dayjs().format("YYYY-MM-DD");
const isSubmitting = ref(false);

async function submit() {
    if (isSubmitting.value || !(await form.value.validate()).valid) {
        return false;
    }

    isSubmitting.value = true;
    try {
        return await props.onSubmit({
            start_date: dayjs(startDate.value).format("YYYY-MM-DD"),
            end_date: endDate.value 
                        ?  dayjs(endDate.value).format("YYYY-MM-DD") 
                        : null,
            // Retain the same key when the dialog retries a network failure.
            idempotency_key: props.idempotency_key,
        });
    } finally {
        isSubmitting.value = false;
    }
}

defineExpose({ submit, });
</script>
